export default "__VITE_ASSET__321f0a6f__"